// @flow
// React Libs
import React from 'react';
// Components
import Tooltip from '../../../../../Resources/Common/Tooltip';
import SimpleDocumentComponent from '../../../Documents/SimpleDocumentComponent';

type Props = {
  hasRights: boolean,
  blocked: boolean,
  proposalUid: string
};

export default function FounderCv({
  hasRights,
  blocked,
  proposalUid
}: Props) {
  return (
    <SimpleDocumentComponent
      title="CV des fondateurs"
      tooltip={Tooltip.DocumentProjectFounderCv.document}
      blocked={blocked}
      hasRights={hasRights}
      proposalUid={proposalUid}
    />
  );
}
